import { Box, Skeleton, Typography } from "@mui/material";
import React from "react";
import {
  bgColor17,
  blackColor,
  blackColor26,
  borderPaymentInfo,
  greyShade35,
  greyShade36,
  whiteColor,
} from "../../configs/styles/muiThemes";

function PaymentInfoCard({ icon, label, value }) {
  return (
    <Box sx={styles.card}>
      <Typography
        variant="body2"
        fontSize={11.5}
        fontWeight={400}
        lineHeight="15px"
        color={blackColor26}
      >
        {label}
      </Typography>

      <Typography
        variant="body2"
        fontSize={13}
        fontWeight={600}
        lineHeight="20px"
        color={blackColor}
        mt="0px !important"
      >
        {value == undefined ? (
          <Skeleton variant="text" width={60} height={18} />
        ) : (
          "₹ " + value
        )}
      </Typography>
    </Box>
  );
}

export default PaymentInfoCard;

const styles = {
  card: {
    gap: "8px",
    padding: "7px 10px",
    borderRadius: "8px",
    position: "relative",
    alignItems: "center",
    background: bgColor17,
    marginTop: "0px",
    borderRadius: "10px",
    marginBottom: "8px",
    border: "1px solid " + bgColor17,
  },
};
